import React from "react";

const HomesectionCard = (props) => {
  return (
    <div className="cont mt-10 rounded-xl  h-[35rem] border-x-gray-200 border-y-gray-200 hover:border-4 lg:w-[30%] lg:h-full">
      <img
        className="h-full w-full rounded-xl"
        src={props.image}
        alt=""
      />
      <div className="overlay1 opacity-90 rounded-xl">
        <div className="text1 font-bold text-black">
          <h1 className="text-xl italic text-gray-400">{props.heading}</h1>
          <h2 className="mt-6 text-2xl text-white">
           {props.heading1}
          </h2>
          <p className="mt-7 text-xl font-thin text-white">
          {props.heading2}
          </p>
          {/* <h1 className="mt-12 text-xl text-blue-400 underline">Read More</h1> */}
        </div>
      </div>
    </div>
  );
};

export default HomesectionCard;
